import { Stack, Text } from '@mantine/core';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

import { FlowStep } from '../../components/layout/FlowStep.tsx';
import { Button } from '../../components/ui/Button/Button.tsx';

export const ThankYou: FC = () => {
  const navigate = useNavigate();

  return (
    <FlowStep
      bodyContent={
        <Stack gap="lg">
          <Text c="gigi-grey-text" ta="center">
            Our team will review your submission within 1-2 business days and will publish it to the Gogigi website.
          </Text>
          <Button
            fullWidth
            text="Go to your dashboard"
            type="button"
            onClick={() => void navigate('/dashboard/pending')}
          />
        </Stack>
      }
      customTopTitle="Thank you!"
      heading="Your Event is submitted!"
    />
  );
};
